import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { toast } from "sonner";
import { useAdminAuth } from "@/hooks/useAdminAuth";
import AdminLogin from "@/components/admin/AdminLogin";
import AdminSidebar from "@/components/admin/AdminSidebar";

/**
 * Shell de /admin/* — pede o PIN uma vez (via AdminAuthProvider, montado
 * em App.js) e depois mostra o menu lateral com as 4 seções, cada uma
 * renderizada no <Outlet/> conforme a rota.
 */
export default function AdminLayout() {
  const { authed, login, logout } = useAdminAuth();
  const [pinDraft, setPinDraft] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    const ok = await login(pinDraft);
    if (ok) {
      toast.success("Acesso liberado");
      setPinDraft("");
    } else {
      toast.error("PIN incorreto");
    }
  };

  if (!authed) {
    return <AdminLogin pin={pinDraft} setPin={setPinDraft} onSubmit={handleLogin} />;
  }

  return (
    <div className="min-h-screen bg-[var(--mn-cream)] lg:flex" data-testid="admin-shell">
      <AdminSidebar onLogout={logout} />
      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
    </div>
  );
}
